<template>
  <div class="register">
    <div class="content">
      <van-field
        label="手机号码"
        ref="mobilePhone"
        required
        center
        placeholder="请输入"
        autocomplete="off"
        type="number"
        maxlength="11"
        inputmode="numeric"
        v-model.trim="accountForm.mobilePhone"
        @click="domfocus($event,'mobilePhone')"
      />
      <van-field
        label="短信验证码"
        ref="captcha"
        required
        autocomplete="off"
        center
        placeholder="请输入"
        inputmode="numeric"
        maxlength="6"
        v-model.trim="accountForm.captcha"
        @click="domfocus($event,'captcha')"
      >
        <template #button>
          <van-button 
            style="width:1.7rem;"
            size="small" 
            type="info"
            native-type="button"
            :disabled=" timer > 0"
            @click="sendSmsVerifyCode($event)"
          >{{ +timer > 0 ? `${timer}s` : '获取验证码' }}</van-button>
        </template>
      </van-field>
      <van-field
        label="登录密码"
        ref="password"
        required
        center
        autocomplete="new-password"
        type="password"
        placeholder="请输入登录密码"
        v-model.trim="accountForm.password"
        @click="domfocus($event,'password')"
      />
      <div class="fix-operate">
        <van-button
          round
          block
          type="info"
          native-type="button"
          @click="onSubmit"
        >修改密码</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { 
  getSmsVerifyCode,
  resetPasswordWithCaptcha,
} from '@/api/baibu';

export default {
  name: 'ProviderRegister',
  data() {
    return {
      // 发送短信间隔
      verifyCodeTime: 60,
      // 倒计时
      timer: 0,
      // 账户表单
      accountForm: {
        mobilePhone: '', // 注册手机号码
        captcha: '', // 短信验证码
        password: '', // 登录密码
      },
      // 类型
      sourceTypeName: 'provider',
    };
  },
  beforeRouteEnter(to, from, next) {
    document.title = '修改密码';
    next();
  },
  mounted() {
    if (this.$route.query.mobilePhone) {
      this.accountForm.mobilePhone = this.$route.query.mobilePhone;
    }
  },
  methods: {
    domfocus(e, ref) {
      e.stopPropagation();
      e.preventDefault();
      if (this.$refs[ref]) {
        this.$refs[ref].focus();
      }
    },
    // 账号表单验证
    accountValidateEvent(name = '') {
      const validate = {
        mobilePhone: [
          { required: true, message: '手机号码不能为空' },
          { pattern: /^1\d{10}$/, message: '手机号码格式不正确' },
        ],
        captcha: [
          { required: true, message: '短信验证码不能为空' },
          { pattern: /^\d{6}$/, message: '短信验证码格式不正确' },
        ],
        password: [
          { required: true, message: '登录密码不能为空' },
        ],
      };
      const errorMessage = this.getValidatorMessage(validate, this.accountForm, name) || '';
      return errorMessage;
    },
    // 获取错误信息
    getValidatorMessage(validate, formData, name) {
      let errorMessage;
      const formList = Object.keys(formData);
      if (name) {
        errorMessage = this.validatorEvent(validate[name], formData[name]);
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < formList.length; i++) {
          const formKey = formList[i];
          const rules = validate[formKey];
          errorMessage = this.validatorEvent(rules, formData[formKey]);
          if (errorMessage) {
            break;
          }
        }
      }
      return errorMessage;
    },
    // 表单验证
    validatorEvent(rules = [], value) {
      let errorMessage = '';
      if (Array.isArray(rules) && rules.length) {
        // eslint-disable-next-line no-plusplus
        for (let j = 0; j < rules.length; j++) {
          if (rules[j].required && !value) {
            errorMessage = rules[j].message;
            break;
          }
          if (rules[j].pattern && !rules[j].pattern.test(value)) {
            errorMessage = rules[j].message;
            break;
          }
          if (rules[j].validator && !rules[j].validator(value)) {
            errorMessage = rules[j].message;
            break;
          }
        }
      }
      return errorMessage;
    },
    // 获取短信验证码时间限制
    setTimer(seconds) {
      this.timer = seconds;
      const interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    // 发送短信验证码
    async sendSmsVerifyCode(e) {
      e.stopPropagation();
      try {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: '正在提交',
        });
        const message = this.accountValidateEvent('mobilePhone');
        if (message) {
          this.$toast(message);
          return;
        }
        const { successful } = await getSmsVerifyCode(
          { phone: this.accountForm.mobilePhone }, 
          { 'req-agent': `${this.sourceTypeName}-h5` },
        );
        this.$toast.clear();

        if (successful) {
          this.$toast('验证码发送成功');
          this.setTimer(this.verifyCodeTime);
        }
      } catch (error) {
        this.$toast.clear();
        console.log(error);
      }
    },
    // 提交表单
    async onSubmit() {
      try {
        const accountErrorMessage = this.accountValidateEvent();
        if (accountErrorMessage) {
          this.$toast(accountErrorMessage);
          return;
        }

        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: '正在提交',
        });
        await resetPasswordWithCaptcha(this.accountForm, {
          'req-agent': `${this.sourceTypeName}-h5`,
        });
        this.$toast('密码修改成功！请前往登录');
        setTimeout(() => {
          this.$toast.clear();
          this.$router.replace({
            path: '/baibu/provider/login',
          });
        }, 1500);
      } catch (error) {
        this.$toast.clear();
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register {
  .content {
    padding: .2rem 0 2rem 0;
    ::v-deep {
      .van-cell:not(:last-child)::after{
        left: 0;
      }
      .van-field__control {
        line-height: 0.48rem;
      }
    }
  }
  .fix-operate {
    display: flex;
    align-items: center;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1.5rem;
    padding: 0 0.3rem;
    background: #fff;
  }
}
</style>
